import { toast } from "react-toastify";
import WebLayout from "../../../layout/WebLayout";
import { useForm } from "react-hook-form";
import ProductAction from "../../../stores/actions/ProductAction";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { RootState } from "../../../stores";
import UpdateVariantModel from "../../../components/UpdateVariantModel";

type FormData = {
  product_code: string;
  barcode: string;
  product_size: string;
  product_color: string;
  case_qty: number;
  mrp: number;
  landing_cost: number;
};

function AddVariant() {
  const routeParams = useParams();
  const productId = routeParams.id;
  const [catModal, setCatModal] = useState<boolean>(false);
  const [editableData, setEditableData] = useState<string>("");
  const modalOpen = (type: string) => {
    setCatModal(true);
  };
  const dispatch = useDispatch<any>();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>();

  const formHandleSubmit = async (data: any, e: any) => {
    e.preventDefault();
    await dispatch(
      ProductAction.addProductVariant({
        product_id: Number(productId),
        product_code: data.product_code,
        barcode: data.barcode,
        product_size: data.product_size,
        product_color: data.product_color,
        qty: data.case_qty,
        mrp: data.mrp,
        landing_cost: data.landing_cost,
      })
    );
    reset();
    getVariantProductList();
  };

  const { colorList, variantProductList } = useSelector(
    (state: RootState) => state.product
  );

  const getVariantProductList = useCallback(async () => {
    await dispatch(ProductAction.getColors());
    await dispatch(
      ProductAction.getVariantProduct({
        productId: Number(productId),
      })
    );
  }, [dispatch]);

  useEffect(() => {
    getVariantProductList();
  }, [getVariantProductList]);

  const deleteVariantData = async (id: any) => {
    if (window.confirm("Are you sure want to delete this variant")) {
      try {
        await dispatch(ProductAction.deleteVariant({ id: id }));
        toast.success("Delete Successfully");
      } catch (e: any) {
        toast.error(e.message);
      }
    }
  };

  return (
    <WebLayout pageName={"AddVariant"}>
      <div className="content-wrapper">
        <div className="container-fluid flex-grow-1 container-p-y">
          <div className="app-ecommerce">
            <div className="row">
              {catModal && (
                <UpdateVariantModel
                  setCatModal={setCatModal}
                  catModal={catModal}
                  getVariantList={getVariantProductList}
                  getVariantData={editableData}
                />
              )}
              <div className="col-12 col-lg-4">
                <form onSubmit={handleSubmit(formHandleSubmit)}>
                  <div className="card mb-4">
                    <div className="card-header d-flex justify-content-between">
                      <h5 className="card-tile mb-0">
                        Add Variant information
                      </h5>
                    </div>
                    <div className="card-body">
                      <div className="col">
                        <label className="form-label">
                          Product Code <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Product Code"
                          {...register("product_code")}
                          required={true}
                        />
                      </div>
                      <div className="col">
                        <label className="form-label">
                          Barcode <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Barcode"
                          {...register("barcode")}
                          required={true}
                        />
                      </div>
                      <div className="col">
                        <label className="form-label">
                          Size <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Size"
                          {...register("product_size")}
                          required={true}
                        />
                      </div>
                      <div className="col">
                        <label className="form-label">
                          Color{" "}
                          <span className="text-success">( Optional )</span>
                        </label>
                        <select
                          className="form-select"
                          {...register("product_color")}>
                          <option value="" selected disabled>
                            Select Color
                          </option>
                          {colorList?.map((value: any, index: number) => {
                            return (
                              <option value={value.color} key={index}>
                                {value.color}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div className="col">
                        <label className="form-label">
                          CASE PACK SIZE QTY
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter Qty"
                          {...register("case_qty")}
                          required={true}
                        />
                      </div>

                      <div className="col">
                        <label className="form-label">
                          MRP <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter MRP"
                          {...register("mrp")}
                          required={true}
                        />
                      </div>
                      <div className="col">
                        <label className="form-label">
                          Ex Factory Price{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Ex Factory Price"
                          {...register("landing_cost")}
                          required={true}
                        />
                      </div>

                      <button type="submit" className="btn btn-primary mt-2">
                        Save Variant
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <div className="col-12 col-lg-8">
                <div className="card mb-4">
                  <div className="card-header d-flex justify-content-between">
                    <h5 className="card-tile mb-0">Variant List</h5>
                  </div>
                  <div className="table-responsive text-nowrap">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>SN.</th>
                          <th>Product Code</th>
                          <th>Barcode</th>
                          <th>Size</th>
                          <th>Color</th>
                          <th>MRP</th>
                          <th>Ex Factory Price</th>
                          <th>Qty</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {variantProductList &&
                          variantProductList.map(
                            (variantProList: any, index: number) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{variantProList.product_code}</td>
                                <td>{variantProList.barcode}</td>
                                <td>{variantProList.size}</td>
                                <td>{variantProList.color}</td>
                                <td>₹ {variantProList.product_variant_mrp}</td>
                                <td>
                                  ₹{" "}
                                  {variantProList.product_variant_landing_cost}
                                </td>
                                <td>
                                  {variantProList.product_variant_min_qty}
                                </td>
                                <td>
                                  <div className="dropdown">
                                    <button
                                      type="button"
                                      className="btn p-0 dropdown-toggle hide-arrow"
                                      data-bs-toggle="dropdown">
                                      <i className="bx bx-dots-vertical-rounded"></i>
                                    </button>
                                    <div className="dropdown-menu">
                                      <a
                                        className="dropdown-item"
                                        onClick={() => {
                                          modalOpen("");
                                          setEditableData(variantProList);
                                        }}
                                        href="javascript:void(0);">
                                        <i className="bx bx-edit-alt me-1"></i>{" "}
                                        Edit
                                      </a>
                                      <a
                                        className="dropdown-item"
                                        onClick={() =>
                                          deleteVariantData(variantProList.id)
                                        }
                                        href="javascript:void(0);">
                                        <i className="bx bx-trash me-1"></i>{" "}
                                        Delete
                                      </a>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default AddVariant;
